package ch.wsl.box.model.shared

case class TableAccess(insert:Boolean, update:Boolean, delete:Boolean)

